import { PagedFilter } from "../misc/pagedFilter";
import { ITeamModel, TeamMemberResult } from "../models/team.model";
import { IUser } from "../models/user.model";
import ServiceBase from "./base.service";

export class TeamsService extends ServiceBase {
  getTeams = async (): Promise<ITeamModel[]> => this.get("teams");

  getTeam = async (code: string): Promise<ITeamModel> =>
    this.get(`teams/${code}`);

  getTeamMembers = async (
    code: string,
    pagedFilter: PagedFilter
  ): Promise<TeamMemberResult> =>
    this.get(
      `teams/${code}/members?pageNumber=${pagedFilter.pageNumber}&pageSize=${pagedFilter.pageSize}&sortField=${pagedFilter.sortField}&sortDescending=${pagedFilter.sortDescending}`
    );

  sendByEmail = async (
    code: string,
    sendByEmail: boolean
  ): Promise<boolean> => {
    return await this.put<boolean>(`teams/${code}/${sendByEmail}`);
  };

  addMember = async (code: string, user: IUser): Promise<void> => {
    await this.post(`teams/${code}`, user);
  };

  removeMember = async (code: string, userId: number): Promise<void> => {
    await this.delete(`teams/${code}/${userId}`);
  };

  setCoordinator = async (code: string, userId: number): Promise<void> => {
    await this.post(`teams/${code}/coordinator/${userId}`);
  };
}

const teamsService = new TeamsService();

export default teamsService;
